const newsSubpath = '/service-news'

export const servicesRoutes = [
  {
    path: `${newsSubpath}`,
    name: 'News Index',
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Index.vue')
  },
  {
    path: `${newsSubpath}/:slug`,
    name: 'News',
    props: true,
    component: () =>
      import(/* webpackChunkName: "news" */ '@/views/news/Show.vue')
  }
]
